import React, { useState } from "react";
import "./index.less";
export default function Banner(props) {
  return (
    <div className="tipsRegistBox">
      {/* <h2 align="center" ><b>公共资源数智采平台用户协议及隐私政策</b></h2> */}
      本平台尊重并保护所有使用服务用户的个人隐私权。为了给您提供更准确、更有个性化的服务，本平台会按照本隐私权政策的规定使用和披露您的个人信息。但本平台将以高度的勤勉、审慎义务对待这些信息。除本隐私权政策另有规定外，在未征得您事先许可的情况下，本平台不会将这些信息对外披露或向第三方提供。本平台会不时更新本隐私权政策。您在同意本平台服务使用协议之时，即视为您已经同意本隐私权政策全部内容。本隐私权政策属于本平台服务使用协议不可分割的一部分。
      <h4><b>1.适用范围</b></h4>
      <div>(a)在您注册本平台帐号时，您根据本平台要求提供的个人注册信息；</div>
      <div>(b)在您使用本平台网络服务，或访问本平台网页时，本平台自动接收并记录的您的浏览器和计算机上的信息，包括但不限于您的IP地址、浏览器的类型、使用的语言、访问日期和时间、软硬件特征信息及您需求的网页记录等数据；</div>
      <div>(c)本平台通过合法途径从商业伙伴处取得的用户个人数据。</div>
      <h4><b>您了解并同意，以下信息不适用本隐私权政策：</b></h4>
      <div>(a)您在使用本平台提供的搜索服务时输入的关键字信息；</div>
      <div>(b)本平台收集到的您在本平台发布的有关信息数据，包括但不限于参与活动、成交信息及评价详情；</div>
      <div>(c)违反法律规定或违反本平台规则行为及本平台已对您采取的措施。</div>
      <h4><b>2.信息的使用</b></h4>
      <div>(a)本平台不会向任何无关第三方提供、出售、出租、分享或交易您的个人信息，除非事先得到您的许可，或该第三方和本平台(含本平台关联公司)单独或共同为您提供服务，且在该服务结束后，其将被禁止访问包括其以前能够访问的所有这些资料。</div>
      <div>(b)本平台亦不允许任何第三方以任何手段收集、编辑、出售或者无偿传播您的个人信息。任何本平台平台用户如从事上述活动，一经发现，本平台有权立即终止与该用户的服务协议。</div>
      <div>(c)为服务用户的目的，本平台可能通过使用您的个人信息，向您提供您感兴趣的信息，包括但不限于向您发出产品和服务信息，或者与本平台合作伙伴共享信息以便他们向您发送有关其产品和服务的信息(后者需要您的事先同意)。</div>
      <h4><b>3.信息共享</b></h4>
      <div>为了在第三方平台分享信息，提供多样化服务，统计分析，定位服务等必要功能用途，我们的平台中嵌入了授权合作伙伴的软件开发包(SDK),我们会对合作方获取信息的软件工具开发包(SDK)进行严格的安全监测，已保护数据安全。已下是我们接入的相关第三方SDK说明：网证通CA、电子保函、电子发票。
       使用目的：额外服务、统计分析</div>
      <h4><b>4.信息披露</b></h4>
      <div>在如下情况下，本平台将依据您的个人意愿或法律的规定全部或部分的披露您的个人信息：</div>
      <div>(a)经您事先同意，向第三方披露；</div>
      <div>(b)为提供您所要求的产品和服务，而必须和第三方分享您的个人信息；</div>
      <div>(c)根据法律的有关规定，或者行政或司法机构的要求，向第三方或者行政、司法机构披露；</div>
      <div>(d)如您出现违反中国有关法律、法规或者本平台服务协议或相关规则的情况，需要向第三方披露；</div>
      <div>(e)其它本平台根据法律、法规或者网站政策认为合适的披露。</div>
      <h4><b>5.信息存储和交换</b></h4>
      <div>本平台收集的有关您的信息和资料将保存在本平台及(或)其关联机房的服务器上，这些信息和资料可能传送至您所在国家、地区或本平台的合法备份机房服务器上。</div>
      <h4><b>6.Cookie的使用</b></h4>
      <div>(a)在您未拒绝接受cookies的情况下，本平台会在您的计算机上设定或取用cookies,以便您能登录或使用依赖于cookies的本平台平台服务或功能。本平台使用cookies可为您提供更加周到的个性化服务，包括推广服务；</div>
      <div>(b)您有权选择接受或拒绝接受cookies。您可以通过修改浏览器设置的方式拒绝接受cookies但如果您选择拒绝接受cookies,则您可能无法登录或使用依赖于cookies的本平台网络服务或功能；</div>
      <div>(c)通过本平台所设cookies所取得的有关信息，将适用本政策。</div>
      <h4><b>7.信息安全</b></h4>
      <div>(a)本平台帐号均有安全保护功能，请妥善保管您的用户名及密码信息。本平台将通过对用户密码进行加密等安全措施确保您的信息不丢失，不被滥用和变造。尽管有前述安全措施，但同时也请您注意在信息网络上不存在"完善的安全措施";</div>
      <div>(b)请您妥善保护自己的个人信息，仅在必要的情形下向他人提供。如您发现自己的个人信息由于本网站泄密，请您立即联络本站客服，以便平台采取相应措施。</div>
      <h4><b>8.本隐私政策的更改</b></h4>
      <div>(a)如果决定更改隐私政策，我们会在本政策中、司法部官方网站中以及我们认为适当的位置发布这些更改，以便您了解我们如何收集、使用您的个人信息，哪些人可以访问这些信息，以及在什么情况下我们会透露这些信息；</div>
      <div>(b)本软件管理单位保留随时修改本政策的权利，因此请经常查看。如对本政策作出重大更改，司法部会通过网站通知的形式告知。为防止向第三方披露自己的个人信息，如联络方式或者邮政地址。请您妥善保护自己的个人信息，仅在必要的情形下向他人提供。如您发现自己的</div>
      <div>个人信息泄密，尤其是本平台用户名及密码发生泄露，请您立即联络本平台客服，以便本平台采取相应措施。</div>
      
    </div>
  );
}
